import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { UsersService } from '../../services/users/users.service';
import { PermissionsService } from '../../services/permissions.service';
import { Subscription, Subject, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportsService } from '../../services/reports/reports.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-list-admin',
  templateUrl: './list-admin.component.html',
  styleUrls: ['./list-admin.component.scss']
})
export class ListAdminComponent implements OnInit, OnDestroy {

  public admin_list = [];
  private subs: Array<Subscription> = [];
  private modalConfig: any = { ariaLabelledBy: 'modal-basic', centered: true };

  public isLoading = false;
  public isSaving  = false;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();
  private dtInitialized = false;

  public deleteIsSuccess = false;
  public editIsSuccess   = false;

  public userId: string;
  public total: number;
  public page  = 1;
  public limit = 10;
  public offset = 0;

  public textSearch: any;
  public selectedRole = '';
  public catalogs = [];
  public role: any;
  public perfil = [];
  dtElement: any;
  area = '';
  profile: any;
  departments: any;
  public profilesList: any[] = [];

  // ── Formulario Nuevo usuario ──────────────────────────────────────────
  public newUserForm: FormGroup;
  public showPassword = false;

  @ViewChild('modalNuevoUsuario') modalNuevoUsuario: TemplateRef<any>;

  // ── Formulario Editar usuario ─────────────────────────────────────────
  public editUserForm: FormGroup;
  public selectedUser: any = null;

  @ViewChild('modalEditarUsuario') modalEditarUsuario: TemplateRef<any>;

  // ── Formulario Actualizar contraseña ──────────────────────────────────
  public passwordForm: FormGroup;
  public showNewPassword     = false;
  public showConfirmPassword = false;

  @ViewChild('modalActualizarContrasena') modalActualizarContrasena: TemplateRef<any>;
  @ViewChild('modalToggleActive') modalToggleActive: TemplateRef<any>;

  constructor(
    private fb: FormBuilder,
    private usersService: UsersService,
    private authService: AuthenticationService,
    private permissionsService: PermissionsService,
    private reportsService: ReportsService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.role = this.authService.currentUserValue.roles;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      language: {
        emptyTable: '',
        zeroRecords: 'No hay coincidencias',
        lengthMenu: 'Mostrar _MENU_ elementos',
        search: 'Buscar:',
        info: 'De _START_ a _END_ de _TOTAL_ elementos',
        infoEmpty: 'De 0 a 0 de 0 elementos',
        infoFiltered: '(filtrados de _MAX_ elementos totales)',
        paginate: { first: 'Prim.', last: 'Últ.', next: 'Sig.', previous: 'Ant.' },
      },
    };

    this.loadAdmins();

    this.subs.push(
      this.reportsService.getValuestoCatalog('Perfil').subscribe(data => this.catalogs = data),
      this.reportsService.getValuestoCatalog('Departments').subscribe(data => this.departments = data),
      this.permissionsService.getProfiles().subscribe(
        data => this.profilesList = (data || []).filter((p: any) => p.active !== false),
        () => this.profilesList = []
      ),
    );

    this.buildNewUserForm();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.subs.forEach(s => s.unsubscribe());
  }

  // ── Carga de lista ────────────────────────────────────────────────────

  private loadAdmins(page = 0): void {
    this.subs.push(
      this.usersService.getAdmins(this.limit, page, this.textSearch, this.selectedRole)
        .pipe(catchError(err => this.authService.handleUnauthorizedError(err)))
        .subscribe(data => {
          this.admin_list = data.List;
          this.total = data.Total;
          if (!this.dtInitialized) {
            this.dtInitialized = true;
            this.dtTrigger.next();
          } else {
            this.rerender();
          }
        })
    );
  }

  public loadPage(page: number): void {
    this.subs.push(
      this.usersService.getAdmins(this.limit, page - 1, this.textSearch, this.selectedRole)
        .pipe(catchError(err => this.authService.handleUnauthorizedError(err)))
        .subscribe(data => {
          this.admin_list = data.List;
          this.total = data.Total;
        })
    );
  }

  // ── Búsqueda ──────────────────────────────────────────────────────────

  getResults(): void {
    this.subs.push(
      this.usersService.getAdmins(this.limit, 0, this.textSearch, this.selectedRole)
        .pipe(catchError(err => this.authService.handleUnauthorizedError(err)))
        .subscribe(data => {
          this.admin_list = data.List;
          this.total = data.Total;
          this.rerender();
        })
    );
  }

  onRoleFilterChange(): void {
    this.page = 1;
    this.offset = 0;
    this.subs.push(
      this.usersService.getAdmins(this.limit, 0, this.textSearch, this.selectedRole)
        .pipe(catchError(err => this.authService.handleUnauthorizedError(err)))
        .subscribe(data => {
          this.admin_list = data.List;
          this.total = data.Total;
          this.rerender();
        })
    );
  }

  clearInputs(): void {
    this.textSearch = '';
    this.subs.push(
      this.usersService.getAdmins(this.limit, 0, '', this.selectedRole)
        .pipe(catchError(err => this.authService.handleUnauthorizedError(err)))
        .subscribe(data => {
          this.admin_list = data.List;
          this.total = data.Total;
          this.rerender();
        })
    );
  }

  rerender(): void {
    this.dtElement?.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  // ── Modal editar rol ─────────────────────────────────────────────────

  setModalContent(content: any, userId: string): void {
    this.userId = userId;
    this.editIsSuccess = false;
    this.modalService.open(content, this.modalConfig);
  }

  setModalDeleteContent(content: any, userId: string): void {
    this.userId = userId;
    this.deleteIsSuccess = false;
    this.modalService.open(content, this.modalConfig);
  }

  updateRol(): void {
    this.subs.push(
      this.usersService.updateRole(this.userId, { roles: this.profile, Area: this.area })
        .pipe(map(() => {
          this.toastr.success('Rol editado correctamente', 'Éxito', { timeOut: 2500 });
          setTimeout(() => window.location.reload(), 1500);
        }))
        .subscribe()
    );
  }

  public deleteUser(): void {
    this.subs.push(
      this.usersService.deleteUser(this.userId)
        .subscribe(resolve => {
          if (resolve.active === false) {
            this.toastr.success('Usuario eliminado correctamente', 'Éxito', { timeOut: 2500 });
            setTimeout(() => {
              this.modalService.dismissAll();
              window.location.reload();
            }, 1500);
          }
        })
    );
  }

  // ── Modal Nuevo usuario ───────────────────────────────────────────────

  private buildNewUserForm(): void {
    this.newUserForm = this.fb.group({
      firstName:   ['', Validators.required],
      lastName:    ['', Validators.required],
      phoneNumber: ['', [Validators.pattern(/^\d{10}$/)]],
      email:       ['', [Validators.required, Validators.email]],
      roles:       ['', Validators.required],
      area:        [''],
      password:    ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  openNuevoUsuario(): void {
    this.buildNewUserForm();
    this.showPassword = false;
    this.modalService.open(this.modalNuevoUsuario, { ...this.modalConfig, size: 'md' });
  }

  saveNuevoUsuario(modal: any): void {
    if (this.newUserForm.invalid) {
      this.newUserForm.markAllAsTouched();
      return;
    }
    this.isSaving = true;
    const v = this.newUserForm.value;
    const payload: any = {
      firstName:   v.firstName,
      lastName:    v.lastName,
      phoneNumber: v.phoneNumber,
      email:       v.email,
      roles:       v.roles,
      password:    v.password,
      adminCreate: true,
    };
    if (v.area) payload.area = v.area;

    this.subs.push(
      this.authService.createUser(payload).subscribe(
        (res) => {
          const newUserId = res?.id;
          const profileKey = payload.roles;
          const profile = this.profilesList.find((p: any) => p.key === profileKey);
          if (newUserId && profile?.id) {
            this.permissionsService.assignProfile(newUserId, profile.id, payload.area).subscribe(
              () => {},
              () => {}
            );
          }
          this.toastr.success('Usuario creado correctamente', 'Éxito', { timeOut: 2500 });
          this.isSaving = false;
          modal.close();
          this.loadAdmins();
        },
        err => {
          const msg = err?.error?.message || 'Error al crear el usuario';
          this.toastr.error(msg, 'Error', { timeOut: 3000 });
          this.isSaving = false;
        }
      )
    );
  }

  isInvalid(field: string): boolean {
    const c = this.newUserForm.get(field);
    return c.invalid && (c.dirty || c.touched);
  }

  getProfileTitle(user: any): string {
    return user?.profile?.title || '—';
  }

  /** Roles con acceso total (legacy) */
  private isFullAccessRole(): boolean {
    const role = this.authService.currentUserValue?.roles;
    return role === 'admin' || role === 'superadmin';
  }

  /** Claves de permiso asociadas a la pantalla /users */
  private canOnUserScreen(action: 'can_view' | 'can_create' | 'can_edit' | 'can_delete'): boolean {
    if (this.isFullAccessRole()) return true;
    const keys = ['ciudadanos', 'seguridad.usuarios', 'usuarios'];
    return keys.some(k => this.permissionsService.can(k, action));
  }

  canCreateUser(): boolean { return this.canOnUserScreen('can_create'); }
  canEditUser(): boolean   { return this.canOnUserScreen('can_edit');   }
  canDeleteUser(): boolean { return this.canOnUserScreen('can_delete'); }

  get roleLabel(): Record<string, string> {
    return {
      superadmin:  'Super administrador',
      admin:       'Administrador',
      supervisor:  'Supervisor',
      funcionario: 'Enlace / Funcionario',
      user:        'Usuario / Ciudadano',
    };
  }

  // ── Modal Editar usuario ──────────────────────────────────────────────

  private buildEditUserForm(user: any): void {
    this.editUserForm = this.fb.group({
      firstName:   [user.firstName || '',   Validators.required],
      lastName:    [user.lastName  || '',   Validators.required],
      phoneNumber: [user.phoneNumber || '', [Validators.pattern(/^\d{10}$/)]],
      email:       [user.email || '',       [Validators.required, Validators.email]],
      roles:       [user.roles || '',       Validators.required],
      area:        [user.Area  || ''],
    });
  }

  openEditarUsuario(user: any): void {
    this.selectedUser = user;
    this.buildEditUserForm(user);
    this.modalService.open(this.modalEditarUsuario, { ...this.modalConfig, size: 'md' });
  }

  saveEditarUsuario(modal: any): void {
    if (this.editUserForm.invalid) {
      this.editUserForm.markAllAsTouched();
      return;
    }
    this.isSaving = true;
    const v   = this.editUserForm.value;
    const id  = this.selectedUser.id;

    const updateInfo$ = this.usersService.updateUserV2(id, {
      firstName:   v.firstName,
      lastName:    v.lastName,
      phoneNumber: v.phoneNumber,
      email:       v.email,
      area:        v.area,
    });

    const updateRole$ = this.usersService.updateRole(id, { roles: v.roles, Area: v.area });

    this.subs.push(
      updateInfo$.subscribe(
        () => {
          updateRole$.subscribe(
            () => {
              const profile = this.profilesList.find((p: any) => p.key === v.roles);
              if (id && profile?.id) {
                this.permissionsService.assignProfile(id, profile.id, v.area).subscribe(() => {}, () => {});
              }
              this.toastr.success('Usuario actualizado correctamente', 'Éxito', { timeOut: 2500 });
              this.isSaving = false;
              modal.close();
              this.getResults();
            },
            err => {
              const msg = err?.error?.message || 'Error al actualizar el perfil';
              this.toastr.error(msg, 'Error', { timeOut: 3000 });
              this.isSaving = false;
            }
          );
        },
        err => {
          const msg = err?.error?.message || 'Error al actualizar el usuario';
          this.toastr.error(msg, 'Error', { timeOut: 3000 });
          this.isSaving = false;
        }
      )
    );
  }

  isInvalidEdit(field: string): boolean {
    const c = this.editUserForm?.get(field);
    return c ? c.invalid && (c.dirty || c.touched) : false;
  }

  // ── Modal Actualizar contraseña ───────────────────────────────────────

  private buildPasswordForm(): void {
    this.passwordForm = this.fb.group(
      {
        password:        ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  private passwordMatchValidator(group: FormGroup): { [key: string]: boolean } | null {
    const pw      = group.get('password')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return pw === confirm ? null : { mismatch: true };
  }

  get passwordMismatch(): boolean {
    return this.passwordForm?.hasError('mismatch') &&
           (this.passwordForm?.get('confirmPassword')?.dirty ||
            this.passwordForm?.get('confirmPassword')?.touched);
  }

  openActualizarContrasena(user: any): void {
    this.selectedUser      = user;
    this.showNewPassword     = false;
    this.showConfirmPassword = false;
    this.buildPasswordForm();
    this.modalService.open(this.modalActualizarContrasena, { ...this.modalConfig, size: 'md' });
  }

  saveActualizarContrasena(modal: any): void {
    if (this.passwordForm.invalid) {
      this.passwordForm.markAllAsTouched();
      return;
    }
    this.isSaving = true;
    const { password } = this.passwordForm.value;

    this.subs.push(
      this.usersService.changePassword(this.selectedUser.email, password).subscribe(
        () => {
          this.toastr.success('Contraseña actualizada correctamente', 'Éxito', { timeOut: 2500 });
          this.isSaving = false;
          modal.close();
        },
        err => {
          const msg = err?.error?.message || 'Error al actualizar la contraseña';
          this.toastr.error(msg, 'Error', { timeOut: 3000 });
          this.isSaving = false;
        }
      )
    );
  }

  isInvalidPwd(field: string): boolean {
    const c = this.passwordForm?.get(field);
    return c ? c.invalid && (c.dirty || c.touched) : false;
  }

  // ── Activar / Desactivar cuenta ───────────────────────────────────────

  confirmToggleActive(user: any): void {
    this.selectedUser = user;
    this.modalService.open(this.modalToggleActive, { ...this.modalConfig, size: 'sm' });
  }

  doToggleActive(modal: any): void {
    this.isSaving = true;
    this.subs.push(
      this.usersService.toggleActive(this.selectedUser.id).subscribe(
        (res) => {
          const label = res?.Active ? 'activada' : 'desactivada';
          this.toastr.success(`Cuenta ${label} correctamente`, 'Éxito', { timeOut: 2500 });
          this.selectedUser.Active = res?.Active;
          this.isSaving = false;
          modal.close();
          this.getResults();
        },
        err => {
          const msg = err?.error?.message || 'Error al cambiar el estado de la cuenta';
          this.toastr.error(msg, 'Error', { timeOut: 3000 });
          this.isSaving = false;
        }
      )
    );
  }

}
